<script setup lang="ts">
import PlusMenuItem from '@app/layout/nav/mobile/components/PlusMenuItem.vue';
import PlusMenuLink from '@app/layout/nav/mobile/components/PlusMenuLink.vue';
import MenuList from '@app/layout/nav/mobile/components/MenuList.vue';
import Icon from '@components/Icon.vue';
import { IconQuestionCircle, IconWhatsapp, IconPhoneInbound, IconEnvelope } from '@icons';
import { trans } from '@tools/translation.ts';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import { URL_CONTACT } from '@tools/routes/routes';
import { storeToRefs } from 'pinia';
import SubmenuItem from '@app/layout/nav/SubmenuItem.vue';
import Typography from '@components/Typography.vue';

const navbarStore = useNavbarStore();
const {
  whatsappLink,
  faqLink,
  calendlyUrl,
  bookAppointmentUrl,
} = storeToRefs(navbarStore);
</script>

<template>
  <MenuList>
    <li v-if="whatsappLink">
      <PlusMenuLink :link="whatsappLink">
        <template #icon>
          <Icon
            :svg="IconWhatsapp"
            width="24"
            height="24"
            fill="gray-darker"
          />
        </template>

        <template #text>
          {{ trans('user_menu.whatsapp') }}
        </template>
      </PlusMenuLink>
    </li>

    <li>
      <PlusMenuItem class="!cursor-default hover:!bg-transparent">
        <template #icon>
          <Icon
            :svg="IconPhoneInbound"
            width="24"
            height="24"
            stroke="gray-darker"
          />
        </template>

        <template #text>
          {{ trans('user_menu.recalled') }}
        </template>
      </PlusMenuItem>
    </li>

    <li>
      <MenuList
        :class="[
          'ml-4',
          'border-0 border-l border-solid border-gray',
          'px-2 pr-0',
          'flex flex-col',
        ]"
      >
        <li>
          <SubmenuItem
            :link="calendlyUrl ?? undefined"
            class="h-12"
          >
            <Typography variant="body">
              {{ trans('user_menu.find_office') }}
            </Typography>
          </SubmenuItem>
        </li>

        <li>
          <SubmenuItem
            :link="bookAppointmentUrl ?? undefined"
            class="h-12"
          >
            <Typography variant="body">
              {{ trans('user_menu.publish_office') }}
            </Typography>
          </SubmenuItem>
        </li>
      </MenuList>
    </li>

    <li v-if="faqLink">
      <PlusMenuLink :link="faqLink">
        <template #icon>
          <Icon
            :svg="IconQuestionCircle"
            width="24"
            height="24"
            fill="gray-darker"
          />
        </template>

        <template #text>
          {{ trans('user_menu.faq') }}
        </template>
      </PlusMenuLink>
    </li>

    <li>
      <PlusMenuLink :link="URL_CONTACT">
        <template #icon="{ isActive }">
          <Icon
            :svg="IconEnvelope"
            width="24"
            height="24"
            :fill="isActive ? 'black' : 'gray-darker'"
          />
        </template>

        <template #text>
          {{ trans('user_menu.send_message') }}
        </template>
      </PlusMenuLink>
    </li>
  </MenuList>
</template>
